var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKids(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 6.0625C6.47375 6.0625 7.15625 5.38 7.15625 4.53125C7.15625 3.6825 6.47375 3 5.625 3C4.77625 3 4.09375 3.6825 4.09375 4.53125C4.09375 5.38 4.77625 6.0625 5.625 6.0625ZM7.375 17V12.625H8.25V8.6875C8.25 7.725 7.4625 6.9375 6.5 6.9375H4.75C3.7875 6.9375 3 7.725 3 8.6875V12.625H3.875V17H7.375Z",
    fill: "#495E57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 6.0625C14.4738 6.0625 15.1562 5.38 15.1562 4.53125C15.1562 3.6825 14.4738 3 13.625 3C12.7763 3 12.0938 3.6825 12.0938 4.53125C12.0938 5.38 12.7763 6.0625 13.625 6.0625ZM15.375 17V12.625H16.25V8.6875C16.25 7.725 15.4625 6.9375 14.5 6.9375H12.75C11.7875 6.9375 11 7.725 11 8.6875V12.625H11.875V17H15.375Z",
    fill: "#495E57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKids);
export default __webpack_public_path__ + "static/media/Kids.d39aa5ab691ae269aa28d65497092a21.svg";
export { ForwardRef as ReactComponent };